import { render } from "./MonthlyOsgbSalesAmount.vue?vue&type=template&id=793454ad"
import script from "./MonthlyOsgbSalesAmount.vue?vue&type=script&lang=js"
export * from "./MonthlyOsgbSalesAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__